import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

// TODO: Nueva paleta de colores para el dashboard?
// TODO: Personalización de esta paleta desde configuración cliente?
function GenerateConfig () {
  return [
    {
      id: '01',
      name: i18n.t('tipos.tax_code.iva'),
      short: i18n.t('tipos.tax_code.iva_short'),
      color: '#1565C0',
    },
    {
      id: '02',
      name: i18n.t('tipos.tax_code.ipsi'),
      short: i18n.t('tipos.tax_code.ipsi_short'),
      color: '#6A1B9A',
    },
    {
      id: '03',
      name: i18n.t('tipos.tax_code.igic'),
      short: i18n.t('tipos.tax_code.igic_short'),
      color: '#00838F',
    },
    {
      id: '04',
      name: i18n.t('tipos.tax_code.irpf'),
      short: i18n.t('tipos.tax_code.irpf_short'),
      color: '#C62828',
    },
    {
      id: '05',
      name: i18n.t('tipos.tax_code.other'),
      short: i18n.t('tipos.tax_code.other'),
      color: '#546E7A',
    },
    {
      id: '06',
      name: i18n.t('tipos.tax_code.itpajd'),
      short: i18n.t('tipos.tax_code.itpajd_short'),
      color: '#2E7D32',
    },
    {
      id: '07',
      name: i18n.t('tipos.tax_code.ie'),
      short: i18n.t('tipos.tax_code.ie_short'),
      color: '#E65100',
    },
    {
      id: '08',
      name: i18n.t('tipos.tax_code.ra'),
      short: i18n.t('tipos.tax_code.ra_short'),
      color: '#880E4F',
    },
    {
      id: '09',
      name: i18n.t('tipos.tax_code.igtecm'),
      short: i18n.t('tipos.tax_code.igtecm_short'),
      color: '#1B5E20',
    },
    {
      id: '10',
      name: i18n.t('tipos.tax_code.iecdpcac'),
      short: i18n.t('tipos.tax_code.iecdpcac_short'),
      color: '#4A148C',
    },
    {
      id: '11',
      name: i18n.t('tipos.tax_code.iiimab'),
      short: i18n.t('tipos.tax_code.iiimab_short'),
      color: '#006064',
    },
    {
      id: '12',
      name: i18n.t('tipos.tax_code.icio'),
      short: i18n.t('tipos.tax_code.icio_short'),
      color: '#BF360C',
    },
    {
      id: '13',
      name: i18n.t('tipos.tax_code.imvdn'),
      short: i18n.t('tipos.tax_code.imvdn_short'),
      color: '#01579B',
    },
    {
      id: '14',
      name: i18n.t('tipos.tax_code.imsn'),
      short: i18n.t('tipos.tax_code.imsn_short'),
      color: '#33691E',
    },
    {
      id: '15',
      name: i18n.t('tipos.tax_code.imgsn'),
      short: i18n.t('tipos.tax_code.imgsn_short'),
      color: '#827717',
    },
    {
      id: '16',
      name: i18n.t('tipos.tax_code.impn'),
      short: i18n.t('tipos.tax_code.impn_short'),
      color: '#FF6F00',
    },
    {
      id: '17',
      name: i18n.t('tipos.tax_code.reiva'),
      short: i18n.t('tipos.tax_code.reiva_short'),
      color: '#AD1457',
    },
    {
      id: '18',
      name: i18n.t('tipos.tax_code.reigic'),
      short: i18n.t('tipos.tax_code.reigic_short'),
      color: '#0277BD',
    },
    {
      id: '19',
      name: i18n.t('tipos.tax_code.reipsi'),
      short: i18n.t('tipos.tax_code.reipsi_short'),
      color: '#00695C',
    },
    {
      id: '20',
      name: i18n.t('tipos.tax_code.ips'),
      short: i18n.t('tipos.tax_code.ips_short'),
      color: '#558B2F',
    },
    {
      id: '21',
      name: i18n.t('tipos.tax_code.rlea'),
      short: i18n.t('tipos.tax_code.rlea_short'),
      color: '#F57F17',
    },
    {
      id: '22',
      name: i18n.t('tipos.tax_code.ivpee'),
      short: i18n.t('tipos.tax_code.ivpee_short'),
      color: '#6D4C41',
    },
    {
      id: '23',
      name: i18n.t('tipos.tax_code.nuclear_power_tax'),
      short: i18n.t('tipos.tax_code.nuclear_power_tax'),
      color: '#37474F',
    },
    {
      id: '24',
      name: i18n.t('tipos.tax_code.nuclear_fuel_storage_tax'),
      short: i18n.t('tipos.tax_code.nuclear_fuel_storage_tax'),
      color: '#78909C',
    },
    {
      id: '25',
      name: i18n.t('tipos.tax_code.idec'),
      short: i18n.t('tipos.tax_code.idec_short'),
      color: '#8D6E63',
    },
    {
      id: '26',
      name: i18n.t('tipos.tax_code.canary_tobacco_tax'),
      short: i18n.t('tipos.tax_code.canary_tobacco_tax'),
      color: '#FF8F00',
    },
    {
      id: '27',
      name: i18n.t('tipos.tax_code.igfei'),
      short: i18n.t('tipos.tax_code.igfei_short'),
      color: '#9E9D24',
    },
    {
      id: '28',
      name: i18n.t('tipos.tax_code.irnr'),
      short: i18n.t('tipos.tax_code.irnr_short'),
      color: '#283593',
    },
    {
      id: '29',
      name: i18n.t('tipos.tax_code.corporate_income_tax'),
      short: i18n.t('tipos.tax_code.corporate_income_tax'),
      color: '#4527A0',
    },
  ]
}

export function TIPOS_CODIGO_IMPUESTO (state) {
  return configHelper.getConfig(state, 'TIPOS_CODIGO_IMPUESTO', GenerateConfig)
}
